export default __webpack_public_path__ + "static/media/NIAS0530.34I-39307_-24777_0.aada8791.jpg";